import { render, staticRenderFns } from "./user-plan.vue?vue&type=template&id=0b531d7c&scoped=true"
import script from "./user-plan.vue?vue&type=script&lang=js"
export * from "./user-plan.vue?vue&type=script&lang=js"
import style0 from "./user-plan.vue?vue&type=style&index=0&id=0b531d7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b531d7c",
  null
  
)

export default component.exports